import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://prueba-production-3353.up.railway.app';

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para añadir el token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Servicios específicos
export const productService = {
  getAll: (page = 1, limit = 8) => api.get(`/products?page=${page}&limit=${limit}`),
  getById: (id) => api.get(`/products/${id}`),
  create: (product) => api.post('/products', product),
  update: (id, product) => api.put(`/products/${id}`, product),
  delete: (id) => api.delete(`/products/${id}`),
};

export const orderService = {
  getAll: () => api.get('/orders'),
  create: (order) => api.post('/orders', order),
  updateStatus: (id, status) => api.put(`/orders/${id}/status?status=${status}`),
  delete: (id) => api.delete(`/orders/${id}`),
};

export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  verify: () => api.get('/auth/verify'),
};

export const stockService = {
  update: (stockUpdate) => api.put('/stock/update', stockUpdate),
};

export const reportService = {
  getSales: () => api.get('/reports/sales'),
};

export const uploadService = {
  uploadFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export const bannerService = {
  getAll: (activeOnly = true) => api.get(`/banners?active_only=${activeOnly}`),
  getById: (id) => api.get(`/banners/${id}`),
  create: (banner) => api.post('/banners', banner),
  update: (id, banner) => api.put(`/banners/${id}`, banner),
  delete: (id) => api.delete(`/banners/${id}`),
};
